import * as am4core from "@amcharts/amcharts4/core";
import type { BaseObject } from "@amcharts/amcharts4/core";
import type {
  PieSeries,
  ColumnSeries,
  LineSeries,
  CircleBullet,
  DateAxis,
  ValueAxis,
  AxisRendererX,
  AxisRendererY,
} from "@amcharts/amcharts4/charts";

export const LightChartTheme = (target: BaseObject): void => {
  if (target.className === "Label") {
    (target as am4core.Label).fill = am4core.color("#41425a");
  }

  if (target.className === "PieSeries") {
    (target as PieSeries).slices.template.stroke = am4core.color("#ffffff");
  }

  if (target.className === "ColumnSeries") {
    const columnSeries = target as ColumnSeries;
    columnSeries.columns.template.stroke = am4core.color("#ffffff");
    columnSeries.columns.template.fillOpacity = 0.6;
  }

  if (target.className === "LineSeries") {
    const lineSeries = target as LineSeries;
    const segment = lineSeries.segments.template;

    const hoverState = segment.states.create("hover");
    hoverState.properties.strokeWidth = 3;

    const dimmed = segment.states.create("dimmed");
    dimmed.properties.stroke = am4core.color("#dadada");

    const bulletDimmed = lineSeries.bulletsContainer.states.create("dimmed");
    bulletDimmed.properties.stroke = am4core.color("#dadada");
  }

  if (target.className === "CircleBullet") {
    (target as CircleBullet).circle.fill = am4core.color("#ffffff");
  }

  if (target.className === "DateAxis" || target.className === "ValueAxis") {
    const tooltip = (target as DateAxis | ValueAxis).tooltip;
    if (tooltip) {
      tooltip.background.fill = am4core.color("#41425a");
      tooltip.background.stroke = am4core.color("#f9f9fb");
    }
  }

  if (
    target.className === "AxisRendererX" ||
    target.className === "AxisRendererY"
  ) {
    const renderer = target as AxisRendererX | AxisRendererY;
    renderer.fill = am4core.color("#41425a");
    // amCharts types FontWeight as a string union, but the original runtime
    // sets the numeric 500; preserved exactly to keep behavior identical.
    renderer.fontWeight = 500 as unknown as am4core.FontWeight;
    renderer.grid.template.stroke = am4core.color("#41425a");

    const labelTooltip = new am4core.Tooltip();
    labelTooltip.background.fill = am4core.color("#41425a");
    labelTooltip.background.stroke = am4core.color("#f9f9fb");
    labelTooltip.pointerOrientation = "left";
    labelTooltip.getFillFromObject = false;
    labelTooltip.label.wrap = true;

    renderer.labels.template.tooltip = labelTooltip;
  }
};
